import { useQueryClient, useMutation } from '@tanstack/react-query'
import { App } from 'antd'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { createFormula } from '../service/formulaService'
import { Formula } from '../types/Formula'
import formulaQueryKeys from './formulaQueryKeys'

export const useCreateFormula = () => {
  const { t } = useTranslation()
  const companyId = useSelector(contextCompanyIdSelector)!
  const queryClient = useQueryClient()
  const { notification } = App.useApp()

  return useMutation({
    mutationKey: ['budget', 'formula', 'create'],
    mutationFn: (data: Formula) => createFormula(data, companyId),
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: formulaQueryKeys.list({ companyId }) })
      notification.success({ message: t('messages:createSuccess') })
    }
  })
}
